export default "__VITE_ASSET__DwRgyTYE__"